import React, { useEffect, useState } from 'react';
import { buscarProductos } from '../../services/data';
import { useAutocompletar, BotonLimpiar } from './useAutocompletar';

// Autocompletar de productos del catálogo. Si el producto no existe se puede escribir igual:
// queda "no catalogado" (productoId null) para que el administrador decida si lo agrega.
export default function ProductoAutocomplete({ value, productoId, onChange, disabled }) {
  const [opciones, setOpciones] = useState([]);
  const { abierto, setAbierto, ref, listId, propsInput, limpiar, botonCerrar } = useAutocompletar();

  useEffect(() => {
    if (!abierto || String(value || '').trim().length < 2) { setOpciones([]); return undefined; }
    let vigente = true;
    const t = setTimeout(() => { buscarProductos(value).then((r) => { if (vigente) setOpciones(r); }).catch(() => { if (vigente) setOpciones([]); }); }, 200);
    return () => { vigente = false; clearTimeout(t); };
  }, [value, abierto]);

  const exacto = opciones.find((p) => p.nombre.trim().toLowerCase() === String(value || '').trim().toLowerCase());
  return (
    <div className="prod-auto" ref={ref}>
      <span className="auto-campo">
        <input {...propsInput} value={value} disabled={disabled} maxLength={200} aria-label="Producto" placeholder="Buscar o escribir producto"
          className={!disabled && value ? 'auto-con-limpiar' : undefined}
          onChange={(e) => { onChange({ producto: e.target.value, productoId: null }); setAbierto(true); }}
          onBlur={() => { if (!productoId && exacto) onChange({ producto: exacto.nombre, productoId: exacto.id }); }} />
        <BotonLimpiar visible={!disabled && !!value} etiqueta="Limpiar producto" onClick={() => limpiar(() => onChange({ producto: '', productoId: null }))} />
      </span>
      {!disabled && value && !productoId && !exacto && !abierto && <small className="prod-auto-nuevo">No catalogado: se reporta igual</small>}
      {abierto && !disabled && (opciones.length > 0 || value) && (
        <ul id={listId} role="listbox" className="prod-auto-lista">
          {botonCerrar}
          {opciones.map((p) => (
            <li key={p.id} role="option" aria-selected={p.id === productoId}>
              <button type="button" onPointerDown={(e) => { e.preventDefault(); onChange({ producto: p.nombre, productoId: p.id }); setAbierto(false); }} onClick={() => { onChange({ producto: p.nombre, productoId: p.id }); setAbierto(false); }}>
                {p.nombre}<small>{[p.unidad, p.categoria].filter(Boolean).join(' · ')}</small></button>
            </li>))}
          {value && !exacto && <li className="prod-auto-libre"><button type="button" onPointerDown={(e) => { e.preventDefault(); setAbierto(false); }} onClick={() => setAbierto(false)}>
            Usar “{value}” (no está en el catálogo)</button></li>}
        </ul>)}
    </div>
  );
}
